import { AppInteraction } from '@org-avp/naap-app-sdk';
import { WebrtcPlayer } from '@org-avp/webrtc-player';
import { AppConfigSchema, CredentialsResponseSchema } from '../schemas';

const STAGE = process.env.RETAIL_PLATFORM_STAGE ?? 'develop';

function getTvmUrl(dealerId: string): string {
  const domainInfix = STAGE === 'prod' ? '' : `.${STAGE}`;
  return `https://devices${domainInfix}.avp.tech/credentials/viaContextToken/${dealerId}`;
}

async function fetchCredentials(app: AppInteraction, dealerId: string) {
  const token = await app.requestContextToken();
  const response = await fetch(getTvmUrl(dealerId), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return CredentialsResponseSchema.parse(await response.json());
}

async function main() {
  const app = await AppInteraction.init();

  const cfgString = await app.requestConfig();
  console.log('Received config:', cfgString);
  const config = AppConfigSchema.safeParse(JSON.parse(cfgString));

  if (!config.success) {
    return;
  }

  const dealerId = config.data.thingName.split('_')[0];
  console.log('Dealer ID:', dealerId);
  
  const player = new WebrtcPlayer();
  await player.connect({
    htmlContainerId: 'video-container',
    displayMode: 'cover',
    signalingOptions: {
      credentialsProvider: () => fetchCredentials(app, dealerId),
      channelName: config.data.thingName,
      clientId: crypto.randomUUID(),
      type: 'aws',
    },
  });

  app.on('config', () => {});
}

main().catch(() => {});
